import React, { useState } from 'react';
import Layout from '../../components/Layout';
import { Card, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import SignUp from './signUp';

const Store = () => {
  const [showThumb, setShowThumb] = useState(false);

  const topRowData = [
    {
      title: `City Datebooks`,
      content: `Not only a practical daily planner, but are also a valuable city resource guide!`,
      imgSrc: `/img/City Datebooks/city_collage.jpg`,
      link: 'city'
    },
    {
      title: `Photo Datebooks`,
      content: `Beautiful and Practical, it includes scenic color photos as well as valuable state resources!`,
      imgSrc: `/img/Photo Datebooks/photo collage for website_cover.jpg`,
      link: 'photo'
    }
  ];

  const bottomRowData = [
    {
      title: `Day By Day Datebooks`,
      content: `A Day By Day Datebook is an inspirational datebook PLUS sixteen pages of biblical references.`,
      imgSrc: `/img/Day By Day Datebooks/Day By Day Cover.jpg`,
      link: 'product/daybyday'
    },
      {
      title: `Health Datebooks`,
      content: `Practical planners for caregivers, patients, and personal wellness.`,
      imgSrc: `/img/Health Datebooks/Caregiver_cover.jpg`,
      link: 'health'
    },
    {
      title: `Business & Organization Datebooks`,
      content: `Business and Organization Datebooks specifically designed and customized for your company.`,
      imgSrc: `/img/Business And Organization Datebooks/business_datebooks.jpg`,
      link: 'business-and-organization'
    }
  
  ];

  const renderRow = (rowData) => (
    <Row>
      {rowData.map(({ title, content, imgSrc, link }, index) => (
        <div className="col-md-6 my-3" key={index}>
          <Card>
            <Card.Img
              variant="top"
              src={imgSrc}
              style={{
                alignSelf: 'center',
                objectFit: 'contain',
                width: title=="Health Datebooks"?"100%":230,
                height: 230,
                marginTop: 10
              }}
            />
            <Card.Body style={{ textAlign: 'center' }}>
              <Card.Title>{title}</Card.Title>
              <Card.Text>{content}</Card.Text>
              <Link
                className="btn btn-danger"
                to={link}
                role="button"
                style={{ width: '100%' }}
              >
                Click Here and Shop for {title}
              </Link>
            </Card.Body>
          </Card>
        </div>
      ))}
    </Row>
  );

  return (
    <Layout title="Home" description="This is the Home page">
      <div>
        {/* Intro Section */}
        <div className="text-center" style={{ marginBottom: 20 }}>
          <p
            className="my-4"
            style={{
              fontWeight: 'bold',
              fontSize: '2.17em',
              color: '#003D71'
            }}
          >
            WARNING: Dates on your calendar are closer than they appear.
          </p>
          <p style={{ fontSize: '1.25em' }}>
            <b>
              Datebook Publishing, Inc. has been providing personalized
              datebooks for cities, businesses, and organizations since 1986.
            </b>
          </p>
          <div className="my-4">
            <img
              src="/img/datebook-banner-black.jpg"
              alt=""
              style={{ width: '303px', height: '95px' }}
            />
          </div>
          <a className="btn btn-primary" href="/layout-and-design">
            Check out our latest Datebook layout and design
          </a>
        </div>

        {/* Plan & Go Video Section */}
        <div
          style={{

            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            marginTop: '2rem',
            marginBottom: '2rem',
          }}
        >
          <button
            style={{
              backgroundColor: showThumb ? '#0056b3' : '#003D71',
              borderColor: '#003D71',
              color: '#fff',
              padding: '0.5rem 1.2rem',
              borderRadius: '5px',
              textDecoration: 'none',
              display: 'flex',
              cursor: 'pointer',
              fontSize: '18px',
              transition: 'all 0.3s ease',

            }}
            onMouseEnter={() => setShowThumb(true)}
            onMouseLeave={() => setShowThumb(false)}
          >
            Plan & Go Video
          </button>

          {/* Thumbnail preview on hover */}
          {showThumb && (
            <img
              id="planGoThumb"
              src="/img/plan-go-thumbnail.jpg"
              alt="Plan & Go Video Thumbnail"
              style={{
                margin: '0 auto',
                marginTop: '10px',
                width: '280px',
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                transition: 'opacity 0.3s ease'
              }}
            />
          )}

          {/* Actual video */}
          <video
            src="/videos/plan-go.mp4"
            controls
            style={{
              width: '100%',
              maxWidth: '400px',
              borderRadius: '10px',
              marginTop: '1rem',
              boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
            }}
          />
        </div>

        {/* Shop Section */}
        <div id="shop" className="text-center">
          <h1 className="my-5">Shop Datebooks</h1>
          {renderRow(topRowData)}
          {renderRow(bottomRowData)}
        </div>

        <SignUp />
      </div>
    </Layout>
  );
};

export default Store;
